import { render, staticRenderFns } from "./OpinionList.vue?vue&type=template&id=ca7ed048&"
import script from "./OpinionList.vue?vue&type=script&lang=js&"
export * from "./OpinionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports